// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';

const CATALOG_USERS = 'CATALOG_USERS';
const CATALOG_PRODUCTS = 'CATALOG_PRODUCTS';

/** Fetch catalog users (credentials) for a given provider. */
export function useCatalogUsers(provider: string, props?) {
  return useRequestQuery(
    [CATALOG_USERS, provider],
    { method: 'get', url: `catalog/${provider}/users` },
    { select: (res) => res.data, defaultData: [], ...props },
  );
}

/** Search catalog products for a given provider. */
export function useCatalogProducts(provider: string, query: Record<string, any>, props?) {
  return useRequestQuery(
    [CATALOG_PRODUCTS, provider, query],
    { method: 'get', url: `catalog/${provider}/search`, params: query },
    { select: (res) => res.data, defaultData: { data: [], results: 0 }, ...props },
  );
}

/** Create catalog user credentials. */
export function useCreateCatalogUser(provider: string, props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post(`catalog/${provider}/users`, values), {
    onSuccess: () => queryClient.invalidateQueries([CATALOG_USERS, provider]),
    ...props,
  });
}

/** Create item entries from catalog items (returns ItemEntry records with IDs). */
export function useCreateCatalogItemEntries(props?) {
  const apiRequest = useApiRequest();

  return useMutation(
    (items: { name: string; cost?: number; description?: string; orderId?: string; estimatedId?: string }[]) =>
      apiRequest.post('catalog/item-entries', { items }),
    { ...props },
  );
}

/** Update catalog user credentials. */
export function useUpdateCatalogUser(provider: string, props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(([id, values]) => apiRequest.put(`catalog/${provider}/users/${id}`, values), {
    onSuccess: () => queryClient.invalidateQueries([CATALOG_USERS, provider]),
    ...props,
  });
}
